import React, { useEffect, useRef, useState } from 'react';

//components
import ModalWrapper from '../../ModalWrapper'
import SimpleTable from  '@/components/elements/global/tables/SimpleTable/SimpleTable';
import BasicButton from  '@/components/elements/global/buttons/BasicButton/BasicButton';
import SimpleBar from 'simplebar-react';
import SimpleSearchInput from  '@/components/elements/search/simpleSearchInput';

//hooks and helpers
import UseAddNewUserGroupModal from './AddNewUserGroupModal.hooks';
import { simpleBarAutoScrollHandler } from  '@/helpers/SimpleBar';

//styling
import "../../../../css/orgSettings/workspaces/AddNewUserGroupModal.scss"



const AddNewUserGroupModal = ({showModal, hideModal} : {showModal: boolean, hideModal: () => void}) => {
    const simpleBarRef = useRef();
    const {headerText, noDataMessage, closeButtonText, tableContent, getMoreUserGroups,  isLoading, moreAvailable, dataLength, searchInputLabel, searchNewGroupString, setSearchNewGroupString} = UseAddNewUserGroupModal(showModal);
    const [tableHeight, setTableHeight] = useState<number>(88)

    useEffect(() => {
        if(!isLoading ) {
            if(dataLength > 0) {
                setTableHeight(getTableHeight())
            }
            else {
                setTableHeight(88);
            }
        }
    },[isLoading, dataLength, tableContent?.rows?.length])

    function getTableHeight(): number {
        if(!tableContent.rows.length) {
            return  88
        }

        return tableContent.rows.length >= 9 ? 400 : tableContent.rows.length * 40 + 35
    }

    return (
        <ModalWrapper isOpen={showModal} onRequestClose={hideModal} className="add-user-group-modal" isFullPage>
            <div className="add-user-group-modal-content">
                <h1>{headerText}</h1>

                <div className='user-groups-top-button-panel'><SimpleSearchInput ariaLabel={searchInputLabel} setSearchString={setSearchNewGroupString} searchString={searchNewGroupString} /></div>

                <SimpleBar
                    className='edit-audience-simple-bar'
                    style={{ maxHeight: 390 , margin: '12px 0 5px', border: '1px solid #e3e3e3', borderRadius:'4px', height: tableHeight, transition: '0.4s height'}}
                    scrollableNodeProps={{ 
                        ref: simpleBarRef,
                        onScroll: (e: React.UIEvent<HTMLElement>) => simpleBarAutoScrollHandler(e, !isLoading && moreAvailable, getMoreUserGroups)
                    }}
                >
                    <SimpleTable
                        isLoading={isLoading && dataLength === 0}
                        simpleTableContent={tableContent} 
                        noDataMessage={noDataMessage}
                        isInfiniteScroll={true}
                        infiniteScrollFetchCondition={isLoading && moreAvailable}
                    />
                </SimpleBar>
            
                <BasicButton content={closeButtonText}  className={"close-button"}  ariaLabel={'Close Modal'} onButtonClick={hideModal} />
            </div>
        </ModalWrapper> 
    );  
}

export default AddNewUserGroupModal;